module.exports = __webpack_public_path__ + "img/UK2.d012e58e.jpg";